import { useUser } from 'context/user.context';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const useRedirectAuthorizedPaths = () => {
  const router = useRouter();
  const [{ user, isLoading }] = useUser();
  useEffect(() => {
    if (user && !isLoading) {
      router.replace('/');
    }
  }, [router, user, isLoading]);
};

//user - true
//isloading - false
